import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FullscreenLoader from "../components/FullscreenLoader";
import Input from "../components/Input";
import { FormType } from "../helpers/types";
import { getCityFromPostCode } from "../helpers/utils";
import { useAuthContext } from "../providers/AuthProvider";
import { useNewApplicationContext } from "../providers/NewApplicationProvider";

const UserInfo = () => {
    const { t } = useTranslation();
    const { form, section, formData, updateForm, schema } = useNewApplicationContext();
    const { user } = useAuthContext();
    const [errors, setErrors] = useState<Record<string, string>>({});

    const getProfileUserInfo = () => {
        if (user) {
            updateForm('user_name', user.fullname);
            updateForm('user_address', user.address)
            updateForm('user_zip', user.zip);
            updateForm('user_city', user.city);
            updateForm('user_email', user.email);
            updateForm('user_phone', user.phone);
        }
    }

    useEffect(() => {
        getProfileUserInfo();
    }, []);

    if (!form || !section) {
        return <FullscreenLoader />
    }

    const sectionSchema = schema?.shape[section.url];
    const formSchema = sectionSchema.shape[form.url];

    const handleInputChange = (name: string, value: string) => {
        updateForm(name, value);

        // Validate the input against the schema
        const inputSchema = formSchema.shape[name];
        if (inputSchema) {
            const result = inputSchema.safeParse(value);
            setErrors((prevErrors) => {
                if (!result.success) {
                    return { ...prevErrors, [name]: result.error.errors[0]?.message || 'Noe er feil' };
                } else {
                    const { [name]: _, ...restErrors } = prevErrors;
                    return restErrors;
                }
            });
        }
    };

    const handleZipChange = (value: string) => {
        let isnum = /^\d+$/.test(value);

        if (isnum && value.length === 4) {
            getCityFromPostCode(value)
                .then((response) => {
                    if (response !== '') {
                        updateForm('user_city', response)
                    }
                });
        } else {
            updateForm('user_city', '');
        }
    }

    
        return (
        <>
            <Header />

            <div className="row g-4">
                <div className="col-12">
                    <Input
                        type="text"
                        value={formData['user_name'] ?? ''}
                        //onChange={(value) => handleInputChange('user_name', value)}
                        label={t('input_fullname_label')}
                        name={t('input_fullname_label')}
                        placeholder={t('input_fullname_placeholder')}
                        error={errors.user_name}
                        disabled
                        required
                        rules={{}}
                    />
                </div>

                <div className="col">
                    <Input
                        type="text"
                        value={formData['user_address'] ?? ''}
                        onChange={(value) => handleInputChange('user_address', value)}
                        label={t('input_address_label')}
                        name={t('input_address_label')}
                        placeholder={t('input_address_placeholder')}
                        error={errors.user_address}
                        maxLength={100}
                        autoComplete="address-line1"
                        required
                        rules={{}}
                    />
                </div>

                <div className="col-lg-3">
                    <Input
                        type="text"
                        value={formData['user_zip'] ?? ''}
                        onChange={(value) => {
                            handleInputChange('user_zip', value);
                            handleZipChange(value)
                        }}
                        label={t('input_zip_label')}
                        name={t('input_zip_label')}
                        placeholder={t('input_zip_placeholder')}
                        error={errors.user_zip}
                        maxLength={4}
                        autoComplete="postal-code"
                        required
                        rules={{}}
                    />
                </div>

                <div className="col">
                    <Input
                        type="text"
                        value={formData['user_city'] ?? ''}
                        label={t('input_city_label')}
                        name={t('input_city_label')}
                        placeholder={t('input_city_placeholder')}
                        error={errors.user_city}
                        disabled
                        required
                        rules={{}}
                    />
                </div>

                <div className="col-lg-8">
                    <Input
                        type="text"
                        value={formData['user_email'] ?? ''}
                        label={t('input_email_label')}
                        name={t('input_email_label')}
                        placeholder={t('input_email_placeholder')}
                        error={errors.user_email}
                        disabled
                        required
                        rules={{}}
                    />
                </div>

                <div className="col-lg-4">
                    <Input
                        type="text"
                        value={formData['user_phone'] ?? ''}
                        label={t('input_phone_label')}
                        name={t('input_phone_label')}
                        placeholder={t('input_phone_placeholder')}
                        error={errors.user_phone}
                        required
                        rules={{}}
                    />
                </div>
            </div >
        </>
    )   
    
}

const Header = () => {
    const { section, form } = useNewApplicationContext();
    if (!section || !form) return false;
    const formIndex = section.forms.findIndex((s: FormType) => s.url === form.url)

    return (
        <div className="my-4 my-lg-5">
            <p className="mb-1">{section.title} - {formIndex + 1} / {section.forms.length}</p>
            <h2>{form.title}</h2>
            {form.introtext && parse(form.introtext)}
        </div>
    )
}

export default UserInfo;